import { createStore } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import logger from "redux-logger";
import rootReducer from "../reducers";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const persistConfig = {
    // Root 
    key: "root",
    //Storage Method (React Native)
    storage,
    blacklist: ["missionMetadata"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = configureStore({
//     reducer: persistedReducer,
//     middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
//     devTools: (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
// })
const store = createStore(persistedReducer, (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__())

let persistor = persistStore(store);

export { store, persistor, }

